import React, { useEffect, useState } from "react";
import { Box, Button, CircularProgress, Grid } from "@mui/material";
import { Formik, Form, FastField } from "formik";
import * as Yup from "yup";
import TextField from "@mui/material/TextField";
import {
  getClientWarehouseById,
  updateClientWarehouse,
} from "../../../api/client";
import { useSnack } from "../../../services/SnakbarProvider";
import { handleError } from "../../../services/errorHandler";
import ClientWarehouseAddressFields from "./addressFields";

const validationSchema = Yup.object().shape({
  name: Yup.string().required("El nombre es obligatorio"),
  street: Yup.string().required("La calle es obligatoria"),
  outNum: Yup.string().required("El número exterior es obligatorio"),
  colony: Yup.string().required("La colonia es obligatoria"),
  municipality: Yup.string().required("El municipio es obligatorio"),
  country: Yup.string().required("El país es obligatorio"),
  state: Yup.string().required("El estado es obligatorio"),
  cp: Yup.string().required("El código postal es obligatorio"),
});

export default function UpdateClientWarehouseForm({ id, onSubmit }) {
  const { openSnack } = useSnack();
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    name: "",
    street: "",
    outNum: "",
    innNum: "",
    colony: "",
    municipality: "",
    country: "",
    state: "",
    cp: "",
  });

  useEffect(() => {
    const fetchWarehouse = async () => {
      try {
        const res = await getClientWarehouseById(id);
        const data = res.data;
        const address = data.address || {};
        setFormData({
          name: data.name || "",
          street: address.street || "",
          outNum: address.outNum || "",
          innNum: address.innNum || "",
          colony: address.colony || "",
          municipality: address.municipality || "",
          country: address.country || "",
          state: address.state || "",
          cp: address.cp || "",
        });
      } catch (e) {
        openSnack(handleError(e), "error");
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchWarehouse();
    }
  }, [id]);

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      await updateClientWarehouse(id, values);
      openSnack("Almacén de cliente actualizado con éxito", "success");
      onSubmit();
    } catch (e) {
      openSnack(handleError(e), "error");
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) return <CircularProgress />;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2, p: 1 }}>
      <Formik
        enableReinitialize
        initialValues={formData}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting }) => (
          <Form>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FastField
                  fullWidth
                  name="name"
                  label="Nombre del almacén"
                  as={TextField}
                />
              </Grid>
              <ClientWarehouseAddressFields />
              <Grid item xs={12}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={isSubmitting}
                  fullWidth
                >
                  Guardar
                </Button>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </Box>
  );
}
